import { useGoToPath } from 'catering/hooks/navigation/useGoToPath';
import { buildOrderSettingsPath } from 'catering/helpers/paths';

export function useGoToOrderSettings() {
  const { go } = useGoToPath();
  return ({
    locationSlug,
    fulfillmentMethod,
    isRedirect = false,
    minFulfillmentDateTime = null,
    shipping_city = null,
    shipping_state = null,
    shipping_postal_code = null,
    shipping_google_place_id = null,
    shipping_street_address_1 = null,
    shipping_country = null,
    shipping_lat = null,
    shipping_lng = null
  }) =>
    go({
      path: buildOrderSettingsPath({
        locationSlug,
        fulfillmentMethod,
        minFulfillmentDateTime,
        shipping_city,
        shipping_state,
        shipping_postal_code,
        shipping_google_place_id,
        shipping_street_address_1,
        shipping_country,
        shipping_lat,
        shipping_lng
      }),
      isRedirect
    });
}
